var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
var Container = styled.div.withConfig({ displayName: "Container", componentId: "sc-ag3t27" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", "px;\n  height: ", "px;\n  display: grid;\n  grid-template-columns: ", ";\n  grid-template-rows: ", ";\n  border: 1px solid ", ";\n  border-radius: 100%;\n  box-sizing: border-box;\n"], ["\n  width: ", "px;\n  height: ", "px;\n  display: grid;\n  grid-template-columns: ", ";\n  grid-template-rows: ", ";\n  border: 1px solid ", ";\n  border-radius: 100%;\n  box-sizing: border-box;\n"])), function (_a) {
    var $width = _a.$width;
    return $width;
}, function (_a) {
    var $width = _a.$width;
    return $width;
}, function (_a) {
    var $width = _a.$width;
    return $width / 2 + "px " + $width / 2 + "px";
}, function (_a) {
    var $width = _a.$width;
    return $width / 2 + "px " + $width / 2 + "px";
}, function (_a) {
    var $color = _a.$color;
    return $color;
});
var PieSegment = styled.div.withConfig({ displayName: "PieSegment", componentId: "sc-18vu9uf" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  box-sizing: border-box;\n  left: -1px;\n  top: -1px;\n  position: relative;\n\n  &:nth-child(1) {\n    border-radius: 100% 0 0 0;\n    background: ", ";\n  }\n  &:nth-child(2) {\n    border-radius: 0 100% 0 0;\n    background: ", ";\n  }\n  &:nth-child(3) {\n    border-radius: 0 0 0 100%;\n    background: ", ";\n  }\n  &:nth-child(4) {\n    border-radius: 0 0 100% 0;\n    background: ", ";\n  }\n"], ["\n  box-sizing: border-box;\n  left: -1px;\n  top: -1px;\n  position: relative;\n\n  &:nth-child(1) {\n    border-radius: 100% 0 0 0;\n    background: ", ";\n  }\n  &:nth-child(2) {\n    border-radius: 0 100% 0 0;\n    background: ", ";\n  }\n  &:nth-child(3) {\n    border-radius: 0 0 0 100%;\n    background: ", ";\n  }\n  &:nth-child(4) {\n    border-radius: 0 0 100% 0;\n    background: ", ";\n  }\n"])), function (_a) {
    var $fill = _a.$fill, $color = _a.$color;
    return $fill === 100 && $color;
}, function (_a) {
    var $fill = _a.$fill, $color = _a.$color;
    return $fill >= 25 && $color;
}, function (_a) {
    var $fill = _a.$fill, $color = _a.$color;
    return $fill >= 75 && $color;
}, function (_a) {
    var $fill = _a.$fill, $color = _a.$color;
    return $fill >= 50 && $color;
});
export var PieChart = function (_a) {
    var className = _a.className, _b = _a.width, width = _b === void 0 ? 20 : _b, _c = _a.color, color = _c === void 0 ? '#FF5767' : _c, _d = _a.fill, fill = _d === void 0 ? 100 : _d;
    return (_jsxs(Container, __assign({ className: className, "$width": width, "$color": color }, { children: [_jsx(PieSegment, { "$color": color, "$fill": fill }, void 0), _jsx(PieSegment, { "$color": color, "$fill": fill }, void 0), _jsx(PieSegment, { "$color": color, "$fill": fill }, void 0), _jsx(PieSegment, { "$color": color, "$fill": fill }, void 0)] }), void 0));
};
export default PieChart;
var templateObject_1, templateObject_2;
